import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const industryImages = [
  '/images/generated/corporate-hotel.jpg',
  '/images/generated/corporate-residence.jpg',
  '/images/generated/corporate-finance.jpg',
  '/images/generated/corporate-retail.jpg',
  '/images/generated/corporate-luxury-sales.jpg',
  '/images/generated/corporate-clinic.jpg',
  '/images/generated/corporate-automotive.jpg',
  '/images/generated/corporate-chauffeur.jpg',
];

const industryKeys = [
  { id: 'hotel', href: '/corporate/hotel' },
  { id: 'residence', href: '/corporate/residence' },
  { id: 'finance', href: '/corporate/finance' },
  { id: 'retail', href: '/corporate/retail' },
  { id: 'luxury-sales', href: '/corporate/luxury-sales' },
  { id: 'clinic', href: '/corporate/clinic' },
  { id: 'automotive', href: '/corporate/automotive' },
  { id: 'chauffeur', href: '/corporate/chauffeur' },
];

const industryLocaleKeys = [
  'hotel', 'residence', 'finance', 'retail', 'luxurySales', 'clinic', 'automotive', 'chauffeur',
];

export default function IndustryCards() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('corporate.industry.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporate.industry.title')}
          </h2>
          {String(t('corporate.industry.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-5"></div>
          {String(t('corporate.industry.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {industryKeys.map((industry, idx) => (
            <Link
              key={industry.id}
              to={industry.href}
              className="card-glow group flex bg-background-50 border border-background-200/60 overflow-hidden cursor-pointer"
            >
              <div className="relative w-40 md:w-48 h-32 md:h-36 flex-shrink-0 overflow-hidden">
                <img
                  src={industryImages[idx]}
                  alt={t(`corporate.industry.${industryLocaleKeys[idx]}.imgAlt`)}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-primary-900/15"></div>
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center relative min-w-0">
                <h3 className="font-heading text-[16px] md:text-[17px] text-foreground-900 tracking-[0.05em] mb-1.5 group-hover:text-accent-600 transition-colors">
                  {t(`corporate.industry.${industryLocaleKeys[idx]}.name`)}
                </h3>
                <p className="text-[14px] md:text-[15px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-3">
                  {t(`corporate.industry.${industryLocaleKeys[idx]}.desc`)}
                </p>
                <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors">
                  <span className="text-[14px] tracking-[0.06em]">{t('corporate.industry.viewDetail')}</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-accent-500/30 to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
              </div>
            </Link>
          ))}
        </div>

        {/* Other industries note */}
        {String(t('corporate.industry.otherNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-center text-[14px] text-foreground-500 tracking-[0.04em] mt-6">{__s}</p>))}
      </div>
    </section>
  );
}
